import React, { useState, Fragment } from 'react';
import {
  Row,
  Collapse,
  Card,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  CardBody,
  Label,
  Input,
  Tooltip
} from 'reactstrap';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import FAQForm from './FAQForm';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import { API_FAQ, gAPI_Users_By_Id } from '../../../../../constants/APIs';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Validation from '../../../../../components/Validation';
import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactDragListView from 'react-drag-listview';
import { List, Typography } from 'antd';

const FAQList = ({
  match,
  handleTotalFAQ,
  faqCollectionList,
  faqList,
  LoadData,
  locale,
}) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [showingIndex, setShowIndex] = useState(0);
  const [faqId, setFaqId] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [comments, setComemnts] = useState('');
  const [isView, setIsView] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleTooltip = (id) => {
    setTooltipOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleIndex = (val) => {
    if (val !== showingIndex) setShowIndex(val);
    else setShowIndex('');
  };

  const handleDeleteToggle = () => {
    setIsDelete(!isDelete);
  };

  const handleEditToggle = () => {
    setIsEdit(!isEdit);
  };

  const handleEditClick = (id) => {
    setFaqId(id);
    handleEditToggle();
  };

  const handleDeleteClick = (id) => {
    setFaqId(id);
    handleDeleteToggle();
  };
  const handleViewToggle = () => {
    setIsView(!isView);
  };

  const handleViewClick = (id) => {
    setFaqId(id);
    handleViewToggle();
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      let body = {
        id: faqId,
        locale: locale,
        userName: res.data.fullName,
        comments: comments,
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_FAQ}`,
        data: body,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          handleDeleteToggle();
          LoadData();
          handleTotalFAQ();
          setComemnts('');
        }
      });
    });
  };

  const handleUpdate = (inputData) => {
    AxiosAPI({
      method: 'put',
      url: `${API_FAQ}/${faqId}`,
      data: inputData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        handleEditToggle();
        LoadData();
        handleTotalFAQ();
      }
    });
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0) return;
    if (type === 'LIST-ITEM') {
      const categories = reorder(faqList, fromIndex, toIndex);
      var data = [];
      categories.map((item, i) => {
        data.push({
          id: item.id,
          displayOrder: i,
        });
      });
      AxiosAPI({
        method: 'post',
        url: `${API_FAQ}/order`,
        data: { data: data },
      })
        .then((res) => {
          LoadData();
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else return new Error('NOT A VALID LIST');
  };

  return (
    <Fragment>
      {faqList !== undefined && faqList.length > 0 && (
        <ReactDragListView
          nodeSelector=".ant-list.draggable"
          lineClassName="dragLine"
          onDragEnd={(fromIndex, toIndex) =>
            onDragEnd(fromIndex, toIndex, 'LIST-ITEM')
          }
        >
          {faqList.map((item, index) => {
            return (
              <List key={index} className="draggable">
                <div className="d-flex flex-row mb-3">
                  <span className="draggable item-center mb-3">
                    <a href="#">
                      <i className="simple-icon-cursor-move"></i>
                    </a>
                  </span>
                  <Colxx xxs="12">
                    <Card
                      className="d-flex mb-0"
                      key={`faqItem_${index}`}
                      style={{ borderRadius: '10px', cursor: 'pointer' }}
                    >
                      <CardBody onClick={() => handleIndex(index)}>
                        <Row style={{ marginTop: '-0.5rem' }}>
                          <Colxx xxs="6">
                            <Button
                              color="black"
                              className="btn-empty btn-link list-item-heading text-left text-one faq-font-size"
                              style={{ marginTop: '-1rem', color: 'black' }}
                              onClick={() => handleIndex(index)}
                              aria-expanded={showingIndex === index}
                            >
                              {item.question}
                            </Button>
                          </Colxx>
                          <Colxx xxs="2">
                            {item.createdBy === 'WebPage'
                              ? 'Web Page'
                              : item.createdBy === 'Sprint'
                                ? 'SynXis'
                                : item.createdBy}
                          </Colxx>
                          <Colxx xxs="2">
                            {item.status === "ReadyToPublish" ? "Ready To Publish" :
                              item.status === "Published" ? <IntlMessages id='dashboards.published' /> :
                                item.status === "Draft" ? <IntlMessages id='dashboards.draft' /> : item.status}
                          </Colxx>
                          <Colxx xxs="2">
                            <div className="float-right mr-3">
                              {item.createdBy === 'WebPage' || item.createdBy === 'SynXis' || item.createdBy === 'Sprint' ? (
                                <div>
                                  <i
                                    onClick={() => handleViewClick(item.id)}
                                    style={{ cursor: 'pointer' }}
                                    className="icon-open"
                                    title='View'>
                                    <svg fill="none" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14" stroke="#90caf9" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /></svg>
                                  </i>
                                  <Fragment>
                                    <b> | </b>
                                    <FontAwesomeIcon
                                      id={`delete-icon-${item.id}`}
                                      icon={faTrashAlt}
                                      style={{ color: 'var(--theme-color-1)', cursor: 'pointer' }}
                                      onClick={() => handleDeleteClick(item.id)}
                                    />
                                    <Tooltip
                                      placement="top"
                                      isOpen={tooltipOpen[item.id] || false}
                                      target={`delete-icon-${item.id}`}
                                      toggle={() => toggleTooltip(item.id)}
                                    >
                                      This action will delete the file.<br />
                                      If External Sources is still active, the file will be created during next Sync event.
                                    </Tooltip>
                                  </Fragment>
                                </div>
                              ) : (
                                <div>
                                  <FontAwesomeIcon
                                    icon={faEdit}
                                    color="#90caf9"
                                    cursor="pointer"
                                    title='Edit'
                                    onClick={() => handleEditClick(item.id)}
                                  />
                                  <Fragment>
                                    <b> | </b>
                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      style={{ color: 'var(--theme-color-1)' }}
                                      cursor="pointer"
                                      title='Delete'
                                      onClick={() => handleDeleteClick(item.id)}
                                    />
                                  </Fragment>
                                </div>
                              )}
                            </div>

                          </Colxx>
                        </Row>
                        {showingIndex === index && (
                          <Row
                            className="mt-0"
                            style={{ marginLeft: '1.5rem' }}
                          >
                            <Colxx xxs="12">
                              <Collapse isOpen={showingIndex === index}>
                                <div
                                  className="accordion-content pt-0"
                                  dangerouslySetInnerHTML={{
                                    __html: item.answer,
                                  }}
                                />
                              </Collapse>
                            </Colxx>
                          </Row>
                        )}
                      </CardBody>
                    </Card>
                  </Colxx>
                </div>
              </List>
            );
          })}
        </ReactDragListView>
      )}

      {isEdit && faqId !== undefined && (
        <FAQForm
          faqCollectionList={faqCollectionList}
          label={'Update FAQ'}
          id={faqId}
          toggle={handleEditToggle}
          submit={handleUpdate}
          visible={isEdit}
        ></FAQForm>
      )}
      {
        isView && faqId !== undefined && (
          <FAQForm
            faqCollectionList={faqCollectionList}
            label={'View FAQ'}
            id={faqId}
            toggle={handleViewToggle}
            submit={handleUpdate}
            visible={isView}
          ></FAQForm>
        )
      }
      {isDelete && faqId !== undefined && (
        <Modal
          isOpen={isDelete}
          toggle={handleDeleteToggle}
          style={{ maxWidth: '600px' }}
        >
          <ModalHeader toggle={handleDeleteToggle}>Delete FAQ</ModalHeader>
          <ModalBody>
            <h6 className="mb-3">Are you sure you want to delete ?</h6>
            <div className="mb-3">
              <Label>Comments</Label>
              <Input
                type="text"
                name="comments"
                value={comments}
                onChange={(e) => {
                  setComemnts(e.target.value);
                }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={handleDelete}>
              Delete
            </Button>
            <Button color="secondary" onClick={handleDeleteToggle}>
              Back
            </Button>
          </ModalFooter>
        </Modal>
      )}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
};

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return {
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(FAQList));
